import { useMutation } from "react-query";
import { apiPost } from "@shared/queryHooks/api";

/* API request functions
--===================================================-- */

const createWwrCheckoutSession = async ({
  jobId,
  wwrCategory,
  wwrJobListingType,
  wwrRegion,
  plan,
}: {
  jobId: number;
  wwrCategory: string;
  wwrJobListingType: string;
  wwrRegion: string;
  plan: string;
}) => {
  return await apiPost({
    path: `/jobs/${jobId}/board_wwr_listings/create_checkout_session`,
    variables: { wwrCategory, wwrJobListingType, wwrRegion, plan },
  });
};

/* Hooks
--===================================================-- */

function useCreateWwrCheckoutSession() {
  return useMutation(createWwrCheckoutSession);
}

export { useCreateWwrCheckoutSession };
